import { Link } from 'react-router-dom';

interface NavCtaLinksProps {
	/** 'desktop' = inline nav bar styling, 'offcanvas' = full-width stacked grid styling. */
	variant: 'desktop' | 'offcanvas';
}

/**
 * The "Become a Partner / Open Demat Account / Login" CTA trio, shared between the
 * desktop nav bar and the mobile offcanvas footer so the two can't drift out of sync.
 */
export const NavCtaLinks: React.FC<NavCtaLinksProps> = ({ variant }) => {
	if (variant === 'desktop') {
		return (
			<>
				<Link
					to={`${process.env.REACT_APP_MAIN_WEBSITE_URL}partner-with-us/`}
					target="_blank"
					className="btn btn-outline-dark nav-btn rounded-3 fs-16 in_semi me-3 text-nowrap">
					Become a Partner
				</Link>
				<a
					href={`${process.env.REACT_APP_MAIN_WEBSITE_URL}open-demat-account/`}
					target="_blank"
					className="bg-color29 nav-btn btn me-3 px-4 in_semi rounded-3 py-2 text-white text-nowrap"
					type="submit">
					Open Demat Account
				</a>
				<Link
					to="https://protrade.jainam.in/"
					target="_blank"
					className="btn btn-outline-dark login-btn rounded-3 fs-16 in_semi">
					Login
				</Link>
			</>
		);
	}

	return (
		<div className="row">
			<div className="col-12 col-md-4 col-lg-4 mt-3 mt-md-0">
				<Link
					to={`${process.env.REACT_APP_MAIN_WEBSITE_URL}partner-with-us/`}
					target="_blank"
					className="btn btn-outline-dark px-4 rounded-3 w-100 py-2 fs-16 in_semi">
					Become a Partner
				</Link>
			</div>
			<div className="col-12 col-md-4 col-lg-4 mt-3 mt-md-0">
				<a
					href={`${process.env.REACT_APP_MAIN_WEBSITE_URL}open-demat-account/`}
					target="_blank"
					className="bg-color29 btn px-4 rounded-3 w-100 py-2 text-white">
					Open Demat Account
				</a>
			</div>
			<div className="col-12 col-md-4 col-lg-4 mt-3 mt-md-0">
				<Link
					to="https://protrade.jainam.in/"
					target="_blank"
					className="btn btn-outline-dark px-4 rounded-3 w-100 py-2 fs-16 in_semi">
					Login
				</Link>
			</div>
		</div>
	);
};
